<template>
	<div class="custom-selects mb-16">
		<div class="tabs-selections">
			<el-select v-model="activeTime" class="select-info" @change="handleTimeChange">
				<el-option v-for="item in timeRange" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<CommonSearch
				:value.sync="searchValue"
				:placeholder="$t('enterprise.default-search')"
				@change="handleSearchChange"
			/>
		</div>
	</div>
</template>

<script setup>
import CommonSearch from '@/components/CommonSearch.vue';
import { ref, computed, getCurrentInstance } from 'vue';

const props = defineProps({
	// 初始时间选择值
	defaultActiveTime: {
		type: String,
		default: ''
	},
	// 初始搜索值
	defaultSearchValue: {
		type: String,
		default: ''
	}
});

const emit = defineEmits(['timeChange', 'searchChange']);

const { proxy } = getCurrentInstance();

// 响应式数据
const activeTime = ref(props.defaultActiveTime);
const searchValue = ref(props.defaultSearchValue);

// 时间范围选项
const timeRange = computed(() => [
	{
		value: '',
		label: proxy.$t('enterprise.all')
	},
	{
		value: 'lastOneYear',
		label: proxy.$t('enterprise.lastOneYear')
	},
	{
		value: 'lastThreeYear',
		label: proxy.$t('enterprise.lastThreeYear')
	},
	{
		value: 'lastFiveYear',
		label: proxy.$t('enterprise.lastFiveYear')
	}
]);

// 处理时间选择变化
const handleTimeChange = () => {
	emit('timeChange', activeTime.value);
};

// 处理搜索变化
const handleSearchChange = () => {
	emit('searchChange', searchValue.value);
};

// 暴露方法和数据，供父组件访问
defineExpose({
	activeTime,
	searchValue,
	reset: () => {
		activeTime.value = '';
		searchValue.value = '';
	}
});
</script>

<style lang="less" scoped>
.custom-selects {
	.tabs-selections {
		display: flex;

		.select-info {
			width: 104px;
			margin-right: 20px;
		}
	}
}
</style>
